// routes/verify-email.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/verify-email')

export const handle = { name: 'verify-email' }

export default dynamic(getClientModule, { ssr: false })
